import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import { getCurrentUser } from '../../api/common'; 
import '../../css/users.css';

function UserView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    axios
      .get(`/api/auth/users/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(res => setUser(res.data))
      .catch(err => {
        console.error('사용자 조회 실패:', err);
        alert('사용자 정보를 불러올 수 없습니다. 로그인 상태를 확인하세요.');
      });
      getCurrentUser(token)
      .then(res => setCurrentUser(res))
      .catch(err => console.error('현재 사용자 조회 실패:', err));

  }, [id, token]);

  const handleDelete = async () => {
    if (window.confirm('정말 삭제하시겠습니까?')) {
      await axios.delete(`/api/auth/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('삭제 완료');
      navigate('/users');
    }
  };

  if (!user) return <div>로딩 중...</div>;
  const canEdit = currentUser && (currentUser.role === 'admin' || currentUser.id === user.id);

    return (
    <div className="container-fluid view-user">
      <div className="row">
        <div className="col-12">

          {/* 상단 고정 버튼 영역 */}
          <div className="user-header-fixed">
            <div className="d-flex gap-2">
              {currentUser?.role === 'admin' && (
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigate('/users')}
                >
                  목록
                </button>
              )}

              {canEdit && (
                <button
                  className="btn btn-outline-info btn-sm"
                  onClick={() => navigate(`/users/edit/${user.id}`)}
                >
                  편집
                </button>
              )}

              {currentUser?.role === 'admin' && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={handleDelete}
                >
                  삭제
                </button>
              )}
            </div>
          </div>


          {/* 회원 기본 정보 */}
          <div className="user-body user-basic mb-4 mt-3 d-flex align-items-start">
            <div className="flex-grow-1">
              <h6 className="fw-bold mb-3">사용자 기본 정보</h6>
              <p><strong>아이디:</strong> {user.userid}</p>
              <p><strong>이름:</strong> {user.name}</p>
              <p><strong>권한:</strong> {user.role}</p>
            </div>
            <div className="ms-3">
              <img
                src={user.photo_path && user.photo_path.trim() !== '' 
                  ? `${user.photo_path}?${new Date().getTime()}`
                  : '/images/img_org_noimage.png'}
                alt="사용자 사진"
                className="user-photo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/images/img_org_noimage.png';
                }}
              />
            </div>
          </div>


          {/* 조직 정보 */}
          <div className="user-body user-org mb-4">
            <h6 className="fw-bold mb-3">부서 및 기타 정보</h6>
            <p><strong>부서 이름:</strong> {user.dept_name || '-'}</p>
            <p><strong>직책:</strong> {user.position || '-'}</p>
            <p><strong>연락처:</strong> {user.phone || '-'}</p>
            <p><strong>이메일:</strong> {user.email || '-'}</p>
            <p><strong>생일:</strong> {user.birthday || '-'}</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UserView;